/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, centerAbsolutely } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ANSWER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	answer: {
		cursor: 'pointer',
		listStyle: 'none',
		margin: '0',
		padding: '0',
		position: 'relative'
	}
};